const modifiedFields = ['groupSelected'];
const modifiedFieldCustom = {
  groupSelected: ['addressBookSq']
};
const sortByFields = {
  groupSelected: ['addressBookSq'],
  orderBy: ['asc']
};
export default { modifiedFields, modifiedFieldCustom, sortByFields };
